<template>
  <CollapsiblePanel
    :variant="['default', 'rounded', '30-12-paddings']"
    :label="$t('_web_tournament_additional_settings_rules', 'Rules')"
    class="rules-title"
  >
    <div class="rules-section-custom-wrapper">
      <div class="row mb-5">
        <TournamentSettingRuleText class="col-8 rules-text" />
      </div>
      <div class="row no-gutters rules-file">
        <TournamentSettingRuleFile class="col-3" />
      </div>
    </div>
  </CollapsiblePanel>
</template>

<script>
import TournamentSettingRuleFile from '@/views/tournaments/management/singleTournament/components/SettingsRuleFile.vue';
import TournamentSettingRuleText from '@/views/tournaments/management/singleTournament/components/SettingsRuleText.vue';
import CollapsiblePanel from '@/components/atoms/CollapsiblePanel';
import { translate } from '@/mixins/translate';

export default {
  name: 'SectionRules',
  components: {
    CollapsiblePanel,
    TournamentSettingRuleFile,
    TournamentSettingRuleText,
  },

  mixins: [translate('_web_tournament_additional_settings')],
};
</script>
<style lang="scss">
.rules-section-custom-wrapper {
  padding: 13px !important;
}

.rules-title .text-block--primary {
  font-size: $hr-heading-5 !important;
}

.rules-text label {
  padding-bottom: 15px;
  font-size: $hr-text-regular !important;
  font-weight: 600;
}

.rules-text .form-control-editable {
  background-color: $hr-bg-header;
  border: 2px solid transparent;
}

.rules-file label {
  padding-bottom: 15px;
  font-size: $hr-text-small !important;
  font-weight: 600;
}

.rules-file :nth-child(1) {
  font-size: $hr-text-regular !important;
  font-weight: 600;
}
</style>
